import Vue from 'vue';
import Vuex from 'vuex';
import sdk from '../sdk';
import task from './Task';
import fission from './Fission';
import fissionV4 from './Fission/fissionV4';
import activity from './Activity';
import activityPage from './ActivityPage';
import video from './Video';
import game from './Game';
import welfare from './Welfare';
import withdraw from './Withdraw';
import fissionV3 from './Fission/v3';
import mall from './Mall';
import App from './App';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		client: {}, // 用户客户端信息
		modal: {
			// 公共弹窗配置
			modalType: '', // 弹窗类型（必传）
			closeFn: null, // 关闭按钮点击事件回调 （必传）
			btnFn: null, // 弹窗内按钮点击事件回调 （非必传）
			pos: null, // 关闭按钮位置 （非必传）
			show: false, // 弹窗显示控制
			props: null,
		},
		toast: {
			// Toast 配置数据
			show: false,
			message: '这是一个toast',
			duration: 2000,
			icon: '',
			position: 'center',
		},
		modalList: [],
		activityPosition: '', // 活动位置；
		// 'kingkong': 金刚区、
		// 'magnet': 福利活动磁贴区
		// 'tasklist': 任务列表、
		// 'magnet-app': app首页磁贴区、
		// 'magnet-withdraw-finish': 提现结果页磁贴区、
		// 'modal-btn': 引流弹窗按钮
		isCompliance: false,
	},
	modules: {
		task,
		fission,
		fissionV4,
		activity,
		video,
		game,
		activityPage,
		welfare,
		withdraw,
		fissionV3,
		mall,
		App,
	},
	mutations: {
		setClient(state, data) {
			state.client = { ...data };
		},
		setModal(state, data) {
			state.modal = Object.assign(state.modal, data);
		},
		setToast(state, data) {
			state.toast = Object.assign(state.toast, data);
		},
		updateActivityPos(state, data) {
			state.activityPosition = data;
		},
		SetModalList(state, list) {
			state.modalList = [...list];
		},
		setIsCompliance(state, data) {
			state.isCompliance = data;
		},
	},
	actions: {
		getClient({ commit }) {
			const info = sdk.appCall('GET_USER_INFO');

			if (info) {
				const client = JSON.parse(info);
				commit('setClient', client || {});
			}

			// commit('setClient', userInfo);
		},
		openModal({ commit, state, dispatch }, data) {
			let { closeFn, show, modalType, props, isNoAllowRepeat } = data;
			let isHadModalType = state.modalList.some((item) => modalType === item.modalType);
			// 存在同名弹窗且不允许重复弹窗
			if (isHadModalType && isNoAllowRepeat) return;
			const originList = state.modalList.map((item) => {
				return { ...item };
			});
			let modalList = [...originList];
			// 默认打开弹框
			if (!show) show = !show;
			// 默认按钮点击事件为关闭弹窗
			if (!closeFn) {
				closeFn = () => {
					dispatch('closeModal', { modalType });
				};
			}
			const modal = { ...data, closeFn, show, props };

			modalList.push(modal);
			commit('SetModalList', modalList);
		},
		closeModal({ commit, state }, data) {
			const list = [...state.modalList];
			let index = -1;
			if (data) {
				const { modalType } = data;

				if (modalType) {
					index = state.modalList.findIndex((item) => item.modalType === modalType);
				}
			}
			if (index > -1) {
				list[index] = {
					...list[index],
					show: false,
				};
				list.splice(index, 1);
			} else {
				// 默认关闭最后一个
				list.pop();
			}

			if (list.length) {
				list[list.length - 1].overlay = true;
			}
			commit('SetModalList', list);
			const htmlElement = document.body;
			htmlElement.style.cssText = htmlElement.style.cssText.replace('overflow: hidden;', ''); // 'scroll';
		},
		toast({ commit, state }, data) {
			let { show, duration } = data;

			// 打开 toast
			if (!show) show = !show;
			if (!duration) {
				duration = state.toast.duration;
			}
			// toast duration 后自动消失
			setTimeout(() => {
				state.toast.show = false;
			}, duration);

			Object.assign(data, { show });

			commit('setToast', data);
		},

		// 视频回调注册方法，fn 为回调函数参数，不能用箭头函数定义次参数
		registerVideoCallback({}, fn, context) {
			console.log('注册视频回调方法！');
			sdk.register('ON_REWARD_VIDEO_PLAYED', fn.bind(context));
		},
	},
	getters: {
		modal(state) {
			return state.modal;
		},
		client(state) {
			return state.client;
		},
		toast: (state) => {
			return state.toast;
		},
		ModalList: (state) => {
			return state.modalList;
		},
		isTourist(state) {
			const { uid, tourist_token, accessToken } = state.client;

			if (uid && accessToken) {
				return false;
			} else if (tourist_token) {
				return true;
			}
			return false;
		},
		isCompliance(state) {
			return state.isCompliance;
		},
	},
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js